import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcDmvDrivingRecordService from '../../../../../service/NcDmvDrivingRecordService';
import NcDmvDrivingRecordModal from './NcDmvDrivingRecordModal';

export default class NcDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      {
        value: 'driversLicenseNumber',
        display: 'Driver License Number',
      },
    ];
  }

  onDrivingRecordSelect(row) {
    const { rows = [], } = this.state;
    const selectedDrivingRecord = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedDrivingRecord: selectedDrivingRecord.raw,
    });
  }

  getDrivingRecords(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'ncdmv_driving_record';

    const allowedKeys = [
      'id',
      'driversLicenseNumber',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcDmvDrivingRecordService.getNcDmvDrivingRecordsBySearchCriteria(criteria)
      .then((response) => {
        const { drivingRecords, } = response.data;
        if (drivingRecords.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          drivingRecords.forEach((drivingRecord) => {
            const filtered = _.pick(drivingRecord, allowedKeys);
            rows.push({
              value: Object.values(filtered),
              raw: drivingRecord,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (drivingRecord) => {
    if (!drivingRecord) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${drivingRecord.id}`}</p>
        <hr />
        <NcDmvDrivingRecordModal selectedDrivingRecord={drivingRecord} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedDrivingRecord: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedDrivingRecord,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getDrivingRecords(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Driving Records">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onDrivingRecordSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedDrivingRecord)}
        </div>
      </div>
    );
  }
}
